export default "__VITE_ASSET__5giNSgIV__"